<template>
    <div id="wrapper">
        <h2>{{ languageNameSt }}</h2>
        <hr/>
        <div class="accolades">
            <div class="accolade">
                <dt>Speaking:</dt><dd :class="cefr[speakingSt]">{{ cefr[speakingSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Writing:</dt><dd :class="cefr[writingSt]">{{ cefr[writingSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Reading:</dt><dd :class="cefr[readingSt]">{{ cefr[readingSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Listening:</dt><dd :class="cefr[listeningSt]">{{ cefr[listeningSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Grammar:</dt><dd :class="cefr[grammarSt]">{{ cefr[grammarSt] }}</dd>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { languageStore } from '@/stores/languages';
    import { defineProps,computed } from 'vue';

    const props = defineProps({
        index:Number
    });

    const language = computed(() => {return languageStore().languages[props.index] || null;});
    const cefr = ['cefr','A1','A2','B1','B2','C1','C2'];

    const languageNameSt = computed(() => language.value.name);
    const writingSt = computed(() => language.value.writing);
    const readingSt = computed(() => language.value.reading);
    const speakingSt = computed(() => language.value.speaking);
    const listeningSt = computed(() => language.value.listening);
    const grammarSt = computed(() => language.value.grammar);
</script>

<style scoped>
    #wrapper
    {
        width:90%;
        background-color: #fff8f2;
        border-radius: 12px;
        padding:2%;
        padding-top:1%;
    }

    .accolades
    {
        display:flex;
        flex-wrap: wrap;
        gap:8px;
        padding:5px 0;
    }

    .accolade
    {
        display: flex;
        gap:2px;
        align-items: center;
    }

    dt,dd
    {
        width:auto;
        margin:0;
        font-size: 18px;
    }

    hr
    {
        border:1px solid black;
    }

    h2,dt,dd
    {
        font-family: Playfair Display;
        color:black;
    }

    dt,h2
    {
        user-select: none;
    }

    dd
    {
        text-shadow: 0px 1px 4px rgb(0 0 0 / 80%);
        font-weight: bold;
    }

    dd.A1
    {
        color:#5ef566;
    }

    dd.A2
    {
        color:#b1f55e;
    }

    dd.B1
    {
        color:#d7f55e;
    }

    dd.B2
    {
        color:#f5e85e;
    }

    dd.C1
    {
        color:#f5845e;
    }

    dd.C2
    {
        color:#f55e9d;
    }
</style>